/*
 * Jira Ticket:
 * Created Date: Wed, 25th Mar 2020, 10:19:12 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import {
  Filter,
  ReferenceInput,
  SelectInput,
  TextInput,
  useTranslate,
} from 'react-admin';
import { filterStyle } from 'styles';

const TowerFilters = ({ organisationFilter, organisationId, ...props }) => {
  const translate = useTranslate();
  const classes = filterStyle();

  return (
    <Filter className={classes.root} {...props}>
      <TextInput source="ref" label={'resources.Tower.fields.id'} alwaysOn />
      <ReferenceInput
        label="resources.User.fields.organisation"
        source="organisationId"
        reference="Organisation"
        emptyText={translate('resources.Tower.noOrganisations')}
        perPage={1000}
        sort={{ field: 'name', order: 'ASC' }}
        onChange={organisationFilter}
        alwaysOn
      >
        <SelectInput
          source="id"
          optionText="name"
          options={{
            InputLabelProps: { shrink: true },
            SelectProps: { displayEmpty: true },
          }}
        />
      </ReferenceInput>
      <ReferenceInput
        label={'resources.Tower.fields.project'}
        source="projectId"
        reference="Project"
        filter={{ principalOrganisationId: organisationId }}
        perPage={1000}
        sort={{ field: 'name', order: 'ASC' }}
        alwaysOn
      >
        <SelectInput source="id" optionText="name" />
      </ReferenceInput>
      <ReferenceInput
        label={'resources.Tower.fields.site'}
        source="siteId"
        reference="Site"
        filter={{ principalOrganisationId: organisationId }}
        perPage={1000}
        sort={{ field: 'name', order: 'ASC' }}
        alwaysOn
      >
        <SelectInput source="id" optionText="name" />
      </ReferenceInput>
    </Filter>
  );
};

export default TowerFilters;
